import type { OverviewAreaGeometry } from '../../pages/OverviewAreaCameraPanel';

export const SHOWCASE_BOOTH_STILL = '/showcase-assets/stills/booth-fallback.svg';
export const SHOWCASE_FORKLIFT_STILL = '/showcase-assets/stills/forklift-fallback.svg';
export const SHOWCASE_PPE_STILL = '/showcase-assets/stills/ppe-fallback.svg';

export const SHOWCASE_BOOTH_ZONE: OverviewAreaGeometry = {
  zoneId: 'showcase-fallback-overlay',
  label: 'Demo zone',
  polygon: [
    [0.18, 0.22],
    [0.62, 0.22],
    [0.62, 0.72],
    [0.18, 0.72],
  ],
  deployed: true,
  measurementScopeKind: 'ZONE_POLYGON',
};
